import React from 'react';
import { SafetyCertificateOutlined, EyeInvisibleOutlined, LockOutlined } from '@ant-design/icons';

const SecurityProtection = () => {
    const securityFeatures = [
        {
            id: 1,
            title: '256-bit SSL Encryption',
            description: 'Your data is protected with bank-level encryption technology',
            icon: <SafetyCertificateOutlined style={{ fontSize: '32px' }} />,
            bgColor: 'bg-green-100',
            iconColor: 'text-green-600'
        },
        {
            id: 2,
            title: 'Secure Transactions',
            description: 'All transactions are encrypted and protected against unauthorized access',
            icon: <LockOutlined style={{ fontSize: '32px' }} />,
            bgColor: 'bg-yellow-100',
            iconColor: 'text-yellow-600'
        },
        {
            id: 3,
            title: 'Privacy Protected',
            description: 'Your financial information is never stored on our servers',
            icon: <EyeInvisibleOutlined style={{ fontSize: '32px' }} />,
            bgColor: 'bg-purple-100',
            iconColor: 'text-purple-600'
        }
    ];

    return (
        <div className="p-6 border-2 border-light rounded-md mt-3 bg-white">
            <h2 className="text-xl font-semibold text-gray-800 mb-3">Security & Protection</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {securityFeatures.map((feature) => (
                    <div key={feature.id} className="text-center">
                        {/* Icon Container */}
                        <div className={`w-16 h-16 ${feature.bgColor} rounded-full flex items-center justify-center mx-auto mb-4`}>
                            <div className={feature.iconColor}>
                                {feature.icon}
                            </div>
                        </div>
                        
                        {/* Title */}
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">
                            {feature.title}
                        </h3>
                        
                        {/* Description */}
                        <p className="text-sm text-gray-600 leading-relaxed">
                            {feature.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SecurityProtection;